// extracted by mini-css-extract-plugin
export var card = "_sc-0";
export var details = "_sc-1";